const TestListAddVersionIcon = (props) => (
  <span className="testCasesHierarchicalListAddVersionIconContainer">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.11301 3.99996L7.44634 5.33329H13.333V12H2.66634V3.99996H6.11301ZM6.66634 2.66663H2.66634C1.93301 2.66663 1.33967 3.26663 1.33967 3.99996L1.33301 12C1.33301 12.7333 1.93301 13.3333 2.66634 13.3333H13.333C14.0663 13.3333 14.6663 12.7333 14.6663 12V5.33329C14.6663 4.59996 14.0663 3.99996 13.333 3.99996H7.99967L6.66634 2.66663Z" fill="#4574D2"/>
      <path d="M7.33301 11.3333V9.33333H5.33301V8H7.33301V6H8.66634V8H10.6663V9.33333H8.66634V11.3333H7.33301Z" fill="#4574D2"/>
    </svg>
  </span>
)

export default TestListAddVersionIcon